var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"fixed":"","elevate-on-scroll":""}},[_c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"src":require("../assets/africon_logo.png"),"width":"120","height":"40"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }